
<template>
    <div class="w100">
        <div  class="w100 pos_re">
            <img src="../../static/img/index/aboutUs_banner.png" class="w100 banner_img">
        </div>
        <div class="w100">
            <div class="content" style="margin-top:6vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title">关于我们</p>
                    <p class="con_title_des">About us</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="dis_row just_bet w100 margin_top_2 aboutUs_des" >
                        <div class="aboutUs_des_left dis_column just_cen">
                            <p class="aboutUs_des_title">公司简介</p>
                            <p class="aboutUs_des_titleDes">创新、诚信、合作、共赢是企业发展的灵魂</p>
                            <p class="aboutUs_des_con">{{defaultInformation.companyName}}，是国内较早从事企业彩铃、视频彩铃、400电话、号码认证等业务的专业化公司！公司致力于为各企业提供优质的增值电信服务！</p>
                            <!-- <p class="aboutUs_des_con">公司主要从事彩铃业务推广与运营，彩铃平台维护已达10年之久。</p>-->
                            <p>秉承诚信经营的理念，依靠高品质配音服务水平，通过严格管理和规范的控制流程，得到了新老客户的好评！</p> 
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w100">
            <div class="content" style="margin:5vw auto">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title">企业使命与愿景</p>
                    <p class="con_title_des">The enterprise mission and vision</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="advantage_con" style="margin-top:5vw">
                        <div class="w100 dis_row ali_cen just_bet advantage_con_item">
                            <div class="advantage_con_item_img dis_row ali_cen just_cen">
                                <img src="../../static/img/index/brief-ction1.jpg" class="h100">
                            </div>
                            <div class="advantage_con_item_con dis_column just_cen"> 
                                <p class="advantage_con_item_t">使命</p>
                                <p class="advantage_con_item_t">为行业赋能/与伙伴共生</p>
                                <p style="margin-top:1.5vw" class="con_title_des">三网合一，方便快捷</p>
                                <p class="con_title_des">安全、可靠、专业、易扩展的解决方案</p>
                            </div>
                        </div>
                        <div class="w100 dis_row ali_cen just_bet advantage_con_item">
                            <div class="advantage_con_item_con dis_column just_cen ali_end"> 
                                <p class="advantage_con_item_t">愿景</p>
                                <p class="advantage_con_item_t">服务世界大多数人</p>
                                <p style="margin-top:1.5vw" class="con_title_des">满足代理商业务快速发展的不同需求</p>
                                <p class="con_title_des">从而帮助代理商取得更优渥的回报</p>
                            </div>
                            <div class="advantage_con_item_img dis_row ali_cen just_cen">
                                <img src="../../static/img/index/brief-ction2.jpg" class="h100">
                            </div>
                        </div>
                        <div class="w100 dis_row ali_cen just_bet advantage_con_item">
                            <div class="advantage_con_item_img dis_row ali_cen just_cen">
                                <img src="../../static/img/index/brief-ction3.jpg" class="h100">
                            </div>
                            <div class="advantage_con_item_con dis_column just_cen"> 
                                <p class="advantage_con_item_t">定位</p>
                                <p class="advantage_con_item_t">在前人成就的基础上更进一步</p>
                                <p style="margin-top:1.5vw" class="con_title_des">致力于为各企业提供优质的增值电信服务</p>
                                <p class="con_title_des">带来全新用户体验</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w100">
            <div class="content" style="margin:0vw auto;margin-bottom:6vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title">服务优势</p>
                    <p class="con_title_des">Service advantages</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="dis_row just_bet ali_cen ringone_cc_banner_div">
                        <div class="ringone_con_banner_con dis_column ali_cen just_cen" v-for="(item,index) in partnerList" :key="index">
                            <img :src=item.img class="ringone_con_banner_con_i">
                            <p class="ringone_con_banner_con_t">{{item.title}}</p>
                            <p style="color:#8a8a8a">{{item.con}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {titleList} from '../assets/js/global.js'
export default {       
    name: 'aboutUs',
    data () {
        return {
            defaultInformation:{},
            partnerList:[{
                img:'../../static/img/index/ser_advan1.png',
                title:'签订合同/结算分成即时',
                con:'通过代理资料审核之后同客户签订渠道合作协议，月初按时结算分成。'
            },{
                img:'../../static/img/index/ser_advan2.png',
                title:'专业高效的客服团队',
                con:'7*24h全天候客服在线，客服响应迅速，团队专业业务能力优秀'
            },{
                img:'../../static/img/index/ser_advan3.png',
                title:'资深经验开发技术支持',
                con:'公司拥有众多经验丰富的软件开发工程师，提供技术支持。'
            },{
                img:'../../static/img/index/ser_advan4.png',
                title:'海量一手资源',
                con:'业务总代理直接合作，无中间商全网，最高返佣，无地域限制。'
            }]
        }
    },
    created(){
        setTimeout(() => {
            this.defaultInformation = defaultInformation
        }, 500);
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.$root.indexTabFlag = 0
        titleList(this.$root.indexTabList,3)
    },
    mounted () {
        window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods:{
        scrollToTop(){
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if(scrollTop > 100){
            this.$root.indexTabFlag = 1
            }else{
            this.$root.indexTabFlag = 0
            }
        }
    }
}
</script>

<style scoped>
    .banner_img{
        width: 100%;
        height: 27.5vw;
    }
    .aboutUs_des{
        background-image: url(../../static/img/index/aboutUs_con.png);
        width: 60vw;
        height: 20vw;
        background-repeat:no-repeat;
        background-size:100% 100%;
        box-shadow: 0px 0px 32px -24px;
    }
    .aboutUs_des_left{
        padding-left: 2vw;
        width: 32vw;
        height: 20vw;
    }
    .aboutUs_des_left{
        font-size: 0.9vw;
        line-height: 1.5vw;
        color: #4c4c4c;
        
    }
    .aboutUs_des_title{
        font-size: 1.3vw;
        color: #333;
        font-weight: bold;
    }
    .aboutUs_des_titleDes{
        font-size: 0.7vw;
        color:#888888;
        margin-top: 0.5vw;
        margin-bottom: 1.1vw;
    }
    .aboutUs_des_con{
        margin-bottom: 0.5vw;
    }
    .aboutus_culture_img{
        height: 28vw;
    }
    .culture_con{
        width:70vw;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        margin-left: -35vw;
    }
    .culture_con_item{
        width: 16vw;
        height: 16.5vw;
        border-radius: 1vw;
        overflow: hidden;
        background: #ffffff;
        transition: all .6s;
    }
    .culture_con_item img{
        width: 100%;
        height: 11.5vw;
    }
    .culture_con_item_con{
        height: 4vw;
        font-size: 0.8vw;
        font-size: #888888;
    }
    .culture_con_item_con_title{
        font-size: 1vw;
        color: #f9ab04;
        margin-bottom: 0.5vw;
    }
    .ringone_cc_banner_div{
        width:75vw ;
        margin-top: 3vw;
    }
    .ringone_con_banner_con{
        width: 15vw;
        height: 15vw;
        border-radius: 0.9vw;
        background-color: #fff;
        font-size: 0.75vw;
        text-align: center;
        line-height: 1.7vw;
        transition: all .6s
    }
    .ringone_con_banner_con:hover,.ringone_con_advantage:hover{
         box-shadow: 0px 0px 32px -24px;
    }
    @media screen and (min-width: 1100px) {
        .culture_con_item:hover{
            transition: all .6s;
            -webkit-transform: translateY(-20px);
            transform: translateY(-20px);
        }
        .ringone_con_banner_con:hover,.ringone_con_advantage:hover{
            transform: translateY(-15px);
        }
    }
    .ringone_con_banner_con p{
        width: 12vw;
    }
    .ringone_con_advantage_text{
        width: 10vw;
        height: 5vw;
    }
    .ringone_con_banner_con_t{
        font-size: 1vw;
        font-weight: bold;
        color: #333;
        margin: 1vw 0;
    }
    .ringone_con_banner_con_i{
        width: 3vw;
    }


    .advantage_con{
        width: 55vw;
    }
    .advantage_con_item{
        width: 100%;
        height: 15vw;
        margin-bottom: 8vw;
    }
    .advantage_con_item_img{
        width: 29vw;
        height: 15vw;
        overflow: hidden;
    }
    .advantage_con_item_img img{
        transition: all 1.5s linear 0s;
    }
    .advantage_con_item_img img:hover{
        transform: scale(1.3);
    }
    .advantage_con_item_con{
        width: 23vw;
        height: 15vw;
        padding: 0 2vw;
        transition: all .3s linear 0s;
    }
    .advantage_con_item_con:hover{
        box-shadow: 0 0 32px -24px;
        transform: scale(1.02);
    }
    .advantage_con_item_t{
        font-size: 1.3vw;
        margin-bottom: 0.2vw;
    }
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue